import * as React from 'react';
import ForecastCount from './ForecastCount';

const ForecastListingHeader = (props) => {
    return (
        <div className='bs5 row'>

            <ForecastCount />
            
        </div>
    );
}

export default ForecastListingHeader;